const state = {
    siteSettings: null,
    captchaData: null,
    globalLoader:false,
    domainName: (window.location.hostname.split('.').slice(-2)[0] ? window.location.hostname.split('.').slice(-2)[0].toUpperCase() : ''),
    clickBetValue: null,
    favouriteGames: [],
    gamesData: null,
    openBetsData: 0,
    leagueWiseMatches: null,
    languagesData:null,
    siteVersion:null,
    underMaintenance:null,
    sportsData: null,
    bonusData:null,
    successMsg: null,
    errorMsg: null,
    depositAmount: 0,
    depoPaymentMethodData: null,
    withdrawalAmount: 0,
    selectedAccountData: null,
    bonusData: [],
    logInData: {
        logInWithMobile: false,
        userIds: []
    },
    userTransactionStakes: null,
    selectedDepositPaymentMethod: null,
    androidclose : false,
};

const getters = {
    siteSettings: state => state?.siteSettings,
    languagesData: state => state?.languagesData,
    captchaData: state => state?.captchaData,
    globalLoader:state => state?.globalLoader,
    domainName: state => state?.domainName,
    clickBetValue: state => state?.clickBetValue,
    clickBetActive: state => state?.clickBetValue?.find(item => item.isSelected) ?? false,
    favouriteGames: state => state?.favouriteGames,
    gamesData: state => state?.gamesData,
    openBetsData: state => state?.openBetsData,
    leagueWiseMatches: state => state?.leagueWiseMatches,
    siteVersion: state => state?.siteVersion,
    underMaintenance: state => state?.underMaintenance,
    sportsData: state => state?.sportsData,
    bonusData: state => state?.bonusData,
    successMsg: state => state?.successMsg,
    errorMsg: state => state?.errorMsg,
    depositAmount:state => state?.depositAmount,
    depoPaymentMethodData:state => state?.depoPaymentMethodData,
    withdrawalAmount:state => state?.withdrawalAmount,
    selectedAccountData:state => state?.selectedAccountData,
    bonusData: state => state?.bonusData,
    logInData: state => state?.logInData,
    userTransactionStakes: state => state?.userTransactionStakes,
    selectedDepositPaymentMethod: state => state?.selectedDepositPaymentMethod,
    androidclose: state => state?.androidclose,
};

const actions = {
    setSettings({ commit }, siteSettings) {
        commit('setSettings', siteSettings);
    },
    setLanguagesData({ commit }, languagesData) {
        commit('setLanguagesData', languagesData);
    },
    setCaptchaData({ commit }, captchaData) {
        commit('setCaptchaData', captchaData);
    },
    setGlobalLoader({ commit }, globalLoader) {
        commit('setGlobalLoader', globalLoader);
    },
    setClickBetValue({ commit }, clickBetValue) {
        commit('setClickBetValue', clickBetValue);
    },
    setFavouriteGames({ commit }, favouriteGames) {
        commit('setFavouriteGames', favouriteGames);
    },
    setGamesData({ commit }, gamesData) {
        commit('setGamesData', gamesData);
    },
    setOpenBetsData({ commit }, openBetsData) {
        commit('setOpenBetsData', openBetsData);
    },
    setLeagueWiseMatches({ commit }, leagueWiseMatches) {
        commit('setLeagueWiseMatches', leagueWiseMatches);
    },
    setSiteVersion({ commit }, siteVersion) {
        commit('setSiteVersion', siteVersion);
    },
    setUnderMaintenance({ commit }, underMaintenance) {
        commit('setUnderMaintenance', underMaintenance);
    },
    setSportsData({ commit }, sportsData) {
        commit('setSportsData', sportsData);
    },
    setBonusData({ commit }, bonusData) {
        commit('setBonusData', bonusData);
    },
    showSuccessModal({ commit }, message) {
        commit('showSuccessModal', message);
        setTimeout(() => {
            commit('showSuccessModal', null);
        }, 2000);
    },
    showErrorModal({ commit }, message) {
        commit('showErrorModal', message);
        setTimeout(() => {
            commit('showErrorModal', null);
        }, 2000);
    },
    setDepositAmount({ commit }, depositAmount) {
        commit('setDepositAmount', depositAmount);
    },
    setDepositPaymentMethodData({ commit }, depoPaymentMethodData) {
        commit('setDepositPaymentMethodData', depoPaymentMethodData);
    },
    setWithdrawalAmount({ commit }, withdrawalAmount) {
        commit('setWithdrawalAmount', withdrawalAmount);
    },
    setSelectedAccountData({ commit }, selectedAccountData) {
        commit('setSelectedAccountData', selectedAccountData);
    },
    setBonusData({ commit }, bonusData) {
        commit('setBonusData', bonusData);
    },
    setLogInData({commit}, data) {
        commit('setLogInData', data)
    },
    setUserTransactionStakes({ commit }, userTransactionStakes) {
        commit('setUserTransactionStakes', userTransactionStakes);
    },
    setSelectedDepositPaymentMethod({ commit }, selectedDepositPaymentMethod) {
        commit('setSelectedDepositPaymentMethod', selectedDepositPaymentMethod);
    },
    Setandroidclose({ commit }, androidclose) {
        commit('Setandroidclose', androidclose);
    },
};

const mutations = {
    setSettings(state, siteSettings) {
        state.siteSettings = siteSettings;
    },
    setLanguagesData(state, languagesData) {
        state.languagesData = languagesData;
    },
    setCaptchaData(state, captchaData) {
        state.captchaData = captchaData;
    },
    setGlobalLoader(state, globalLoader) {
        state.globalLoader = globalLoader;
    },
    setClickBetValue(state, clickBetValue) {
        state.clickBetValue = clickBetValue;
    },
    setFavouriteGames(state, favouriteGames) {
        state.favouriteGames = favouriteGames;
    },
    setGamesData(state, gamesData) {
        state.gamesData = gamesData;;
    },
    setOpenBetsData(state, openBetsData) {
        state.openBetsData = openBetsData;;
    },
    setLeagueWiseMatches(state, leagueWiseMatches) {
        state.leagueWiseMatches = leagueWiseMatches;;
    },
    setSiteVersion(state, siteVersion) {
        state.siteVersion = siteVersion;
    },
    setUnderMaintenance(state, underMaintenance) {
        state.underMaintenance = underMaintenance;
    },
    setSportsData(state, sportsData) {
        state.sportsData = sportsData;
    },
    setBonusData(state, bonusData) {
        state.bonusData = bonusData;
    },
    showSuccessModal(state, message) {
        state.successMsg = message
    },
    showErrorModal(state, message) {
        state.errorMsg = message
    },
    setDepositAmount(state, depositAmount){
        state.depositAmount =  depositAmount
    },
    setDepositPaymentMethodData(state, depoPaymentMethodData){
        state.depoPaymentMethodData =  depoPaymentMethodData
    },
    setWithdrawalAmount(state, withdrawalAmount){
        state.withdrawalAmount =  withdrawalAmount
    },
    setSelectedAccountData(state, selectedAccountData){
        state.selectedAccountData =  selectedAccountData
    },
    setBonusData(state, bonusData) {
        state.bonusData = bonusData;
    },
    setLogInData(state, data) {
        state.logInData = data
    },
    setUserTransactionStakes(state, userTransactionStakes) {
        state.userTransactionStakes = userTransactionStakes;
    },
    setSelectedDepositPaymentMethod(state, selectedDepositPaymentMethod) {
        state.selectedDepositPaymentMethod = selectedDepositPaymentMethod;
    },
    Setandroidclose(state, androidclose) {
        state.androidclose = androidclose;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};